import { editorPicks } from "@/mocks/homeData";

export default function EditorPicks() {
  return (
    <section className="px-4 md:px-8 py-12 border-t border-background-200/60">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] text-secondary-600 font-label mb-2">EDITORIAL</p>
          <h2 className="font-heading text-xl md:text-3xl font-black text-foreground-950">编辑推荐 · 本期专题</h2>
        </div>
        <p className="hidden md:block text-sm text-foreground-500">3 篇编辑手记</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {editorPicks.map((pick) => (
          <a href="#collections" key={pick.title} className="group block cursor-pointer">
            <div className="relative w-full h-[220px] md:h-[240px] rounded-lg overflow-hidden bg-background-100">
              <img
                src={pick.image}
                alt={pick.title}
                title={`${pick.title} 91网编辑推荐`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <p className="mt-4 text-xs tracking-[0.2em] text-primary-600 font-label">{pick.kicker}</p>
            <h3 className="mt-2 font-heading text-lg font-black text-foreground-950 leading-snug group-hover:text-primary-600">
              {pick.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{pick.desc}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-time-line" /> {pick.meta}
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}